import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { FlorderDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { PanelStatus } from 'app/modules/florder/florder-edit-container/florder-edit.interface';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { appSettings } from '../../../appSettings';

@Component({
  selector: 'app-florder-select-customer',
  templateUrl: './florder-select-customer.component.html',
  styleUrls: ['./florder-select-customer.component.scss'],
  animations: [
    trigger('growInOut', [
      state('in', style({ height: '50px' })),
      transition('void => *', [style({ height: 0 }), animate(400)]),
      transition('* => void', [animate(400, style({ height: 0 }))]),
    ]),
  ],
})
export class FlorderSelectCustomerComponent implements OnInit, OnChanges {
  @Input() panelStatus: PanelStatus;
  @Input() customer: Definition;
  @Input() customers: Definition[];
  @Input() showCancel: boolean;

  @Output() nextClicked = new EventEmitter();
  @Output() formValidChanged = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();

  customerForm;
  labelWidth = appSettings.LABEL_WIDTH;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderDetail && changes.orderDetail.previousValue && changes.orderDetail.previousValue.etmOrderNumber && !changes.orderDetail.currentValue.etmOrderNumber) {
      this.ngOnInit();
    }
  }

  createForm(): void {
    // Remember async validation errors
    this.customerForm = this.formBuilder.group({
      customer: [this.customer, [Validators.required]],
    });
    this.formValidChanged.emit(this.customerForm.valid);
    this.customerForm.statusChanges
      .pipe(
        map(data => this.customerForm.valid),
        distinctUntilChanged()
      )
      .subscribe(valid => {
        this.formValidChanged.emit(valid);
      });
  }

  doNextClicked() {
    if (this.customerForm.valid) {
      this.nextClicked.emit(this.customerForm.value);
    }
  }
}
